import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div>
      <div class="title"><h1>Welcome to JP's Helping Hand</h1></div>

      <div class="main">
        <div class="menubar">
          <ul>
            <li><a href="/">About Us</a></li>
            <li><a href="/TalkingOutLoudforKids">Talking Out loud for Kids</a></li>
            <li><a href="/TalkingOutLoudforEveryone">Talking Out loud for Everyone</a></li>
            <li><a href="https://docs.google.com/forms/d/e/1FAIpQLSf2f6PIk25F9-VIq4bTU1W9HAklzTdDJsJu6O6O506H-NMLng/viewform?usp=sf_link">Contact US</a></li>
            <li><a class="active" href="/PrivacyPolicy">Privacy Policy</a></li>
          </ul>
        </div>

        <h2>Privacy Policy for Talking Out Loud for Kids</h2>

        <p>Talking Out Loud for Kids does not promote any advertisement, violence, or profanity.</p>
        <p>Talking Out Loud for Kids does not store email or user information associated with your Google / Microsoft account upon installation of the app.</p>
        <p>Talking Out Loud for Kids may say any message out loud generated during your use of Talking Out Loud for Kids.</p>
        <p>Talking Out Loud for kids may be uninstalled from your device at any time by visiting the app page in the Google Play Store / Microsoft Store.</p>
        <br />
        <h2>Privacy Policy for Talking Out Loud for Everyone</h2>

        <p>Talking Out Loud for Everyone does not promote any advertisement, violence, or profanity.</p>
        <p>Talking Out Loud for Everyone does not store email or user information associated with your Google / Microsoft account upon installation of the app.</p>
        <p>Talking Out Loud for Everyone may say any message out loud generated during your use of Talking Out Loud for Everyone.</p>
        <p>Talking Out Loud for Everyone may store data such as phrases on your device.</p>
        <p>Talking Out Loud for Everyone may be uninstalled from your device at any time by visiting the app page in the Google Play Store / Microsoft Store.</p>
        <h2>General</h2>
        <p>We take privacy seriously any and all privacy complaints will be resolved in a timely and efficient manner. Should you have any concerns about privacy, please reach out to us at jp@jpshelpinghand.com.</p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;